import { Environment, eul10n, l10n } from './shared.models';

export const environment: Environment = {
  production: false,
  devTools: true,
  hmr: false,
  name: 'qa',
  authEnv: 'dev',
  appUrl: 'https://maps.qa.dev.vdo-fleet.com',
  useSettingsApi: false,
  datadog: {
    applicationId: '376213ad-4a16-4ec0-9af4-43bfaf54fbc1',
    clientToken: 'pub07dd18e3a77864f9153835ece3c3c745',
    tagEnvironment: 'tm-qa'
  },
  devCycle: {
    clientId: 'dvc_client_08470c3a_5461_468e_98e9_3a65f3e3a2db_c1b538c'
  },
  here: {
    apiKeyV3: 'L9xQLvUWGuArXYtky8qlYqb5dMCHoGhPoBDfQFqh_QY'
  },
  auth: {
    clientID: '6713A4WyP8UQNwnFiGSV5eCeTvzmP36U',
    // clientID: 'zV6qL0stsqonubi0IvLLw6WPwzwgre4O',
    // domain: 'auth.dev.continental-mobility-services.com',
    domain: 'login.auth.dev.vdo-fleet.com',
    // audience: 'https://api.dev.continental-mobility-services.com',
    audience: 'https://api.fleet.vdo.com',
    applicationId: 'fb8e38e1-9403-444e-aa6c-046b33ccab3c',
    useRefreshTokens: true,
    maxAge: 36000,
    connection: 'qa-tisadmin-backend'
  },
  locationApi: {
    url: 'https://api.qa.vdo-fleet.com/historical-asset-service/api/v1',
    hasAssociatedDevice: true
  },
  pathApiBase: {
    url: 'https://api.qa.vdo-fleet.com/historical-asset-service/api/v1'
    //url: 'http://localhost:8251/api/v1'
    //url: 'http://localhost:8080/api/v1'
  },
  geocoderApiBase: {
    // url: 'https://geocoder.dev.eu.zonarsystems.net/api/v1'
    url: 'https://api.qa.vdo-fleet.com/geocoder-service/api/v1'
  },
  pathApiRequestPageSize: 2000,
  dataUpdateMessages: {
    // units are minutes
    updateInterval: 1,
    idling: 60 * 12,
    notIdling: 15
  },
  nearbyAssets: {
    searchRadiusMeters: 50 * 1609, // 50 miles in meters
    assetsToReturn: 10,
    searchRadiusInKm: 80, // 80 km
    searchRadiusInMiles: 50 // 50 miles
  },
  liveUpdate: {
    pageSize: 150,
    concurrency: 7,
    pollingInterval: 10_000,
    consecutiveFailureLimit: 3,
    restartPollingDelay: 30_000
  },
  // zTrakBatteryAlertPct: 0.1,
  apiRequestPageSize: 500,
  datadogSite: 'datadoghq.eu',
  minimumTripMS: 60000,
  featureFlags: {
    assetIOs: true
  },
  region: 'EU',
  vdofleet: {
    baseApiUrl: 'https://api.qa.vdo-fleet.com',
    baseApiAudience: 'https://api.fleet.vdo.com'
  },
  // gtcxUrl: { can add gtcx urls in the future if they go to EU },
  euUrl: {
    vdoDashboardUrl: 'https://qa.vdo-fleet.com',
    vdoReportsUrl: 'https://qa.vdo-fleet.com/reports/',
    geofencingUrl: 'https://qa.vdo-fleet.com/geofencing/'
  },
  i18n: {
    supportedLanguages: [
      'en-US',
      'de-DE',
      'en-GB',
      'es-ES',
      'fr-FR',
      'it-IT',
      'bg-BG',
      'cs-CZ',
      'el-GR',
      'lt-LT',
      'pl-PL',
      'pt-PT',
      'ro-RO',
      'hr-HR',
      'sk-SK',
      'sl-SI',
      'mk-MK',
      'et-EE',
      'nb-NO',
      'nl-NL'
    ],
    defaultLanguage: 'en-GB'
  },
  l10n: eul10n,
  hamburgerMenuEnabled: false
  // legacyAccountsEnabled: false
};
